import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Tabs,
  getColor,
  Icons,
  Typography,
  Dropdown,
  Tooltip,
} from "fds";
import "./index.scss";
import dayjs from "dayjs";
import useCheckboxGroup from "fds/src/hooks/useCheckboxGroup";
import utilsCommon from "../../shared/utils/common";
import { DocumentListReq, DocumentListResp } from "../../types/files";
import { meetingDTO, MeetingRequest } from "../../types/meeting";
import DocumentBottom from "../../components/DocumentBottom";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import MeetingBottom from "../../components/MeetingBottom";
import { Member, Workgroup } from "../../types/workgroup";
import DateDropdown from "../../components/DateDropdown";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { useNavigate } from "react-router-dom";
import useMeetingStore from "../../redux/dispatcher/useMeetingStore";
import UserSearchField from "../../components/UserSearchField";
import { Trans } from "react-i18next";
import { t } from "i18next";
import WorkgroupCheckboxDropdown from "../../components/WorkgroupCheckboxDropdown";
import UserSearchDropdown from "../../components/UserSearchDropdown";
export const INIT_CONTENT_FILTER = {
  date: {
    start: utilsCommon.getStartPeriod("1month"),
    end: dayjs().endOf("day").valueOf(),
  },
  folderCode: "",
  masterUserId: "",
  order: "datedesc",
  page: 0,
  readType: "",
  search: "",
  size: 50,
  tagCodes: [],
};
export const INIT_MEETING_FILTER = {
  date: {
    start: utilsCommon.getStartPeriod("1month"),
    end: dayjs().endOf("day").valueOf(),
  },
  order: "datedesc",
  pageNo: 0,
  resultSize: 20,
  searchFor: "filterSearch",
  searchKeyword: "",
  searchUser: "",
  startTime: "",
  timeDirection: "",
  ver: "1.0",
  workgroupIds: [],
} as MeetingRequest;
const Search = () => {
  const urlParmas = new URLSearchParams(window.location.search);

  /** Hook 정리 */
  const navigate = useNavigate();
  const { workgroupState, getWorkgroupSimpleList } = useWorkgroupStore();
  const { meetingState, getMeetingListBySearchKeyword } = useMeetingStore();
  const { documentState, getContentList } = useDocumentStore();
  const checkboxGroup = useCheckboxGroup();

  /** State정리 */
  const [workgroups, changeWorkgroups] = useState<Workgroup[]>([]);
  const [meetingList, changeMeetingList] = useState<meetingDTO[]>([]);
  const [docInfo, changeDocInfo] = useState<DocumentListResp>();
  const [docFilter, changeDocFilters] =
    useState<DocumentListReq>(INIT_CONTENT_FILTER);
  const [meetingFilter, changeMeetingFilters] =
    useState<MeetingRequest>(INIT_MEETING_FILTER);
  const [dateFilter, changeDateFilter] = useState<string>("1month");
  const [tab, changeTab] = useState<number>(0);
  const [buttonClick, setButtonClick] = useState(0);
  const [keyword, changeKeyword] = useState("");
  const [users, changeUsers] = useState<Member[]>([]);
  const [savedUsers, changeSavedUsers] = useState<Member[]>([]);

  /** Use Effect 정리 */
  useEffect(() => {
    getWorkgroupSimpleList({
      isDetail: "Y",
      managerId: "",
      orderBy: "workgroupName",
      orderByType: "ASC",
      pageRange: 1,
      posPage: 1,
      rowRange: 0,
      searchDate: {
        start: 0,
        end: 0,
      },
      status: 1,
      workgroupName: "",
    });
  }, []);
  useEffect(() => {
    /** url 에서 50자 이상 들어올 경우를 위해 50 자 제한 */
    const givenKeyWord = urlParmas
      .get("key")
      ?.trim()
      .substring(0, 50)
      .replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\u200D|\uFE0F)/g,
        ""
      );
    /** url 에 key가 없을 경우엔 sessionStorage에 저장해둔 가장 최신 키워드 사용. 없으면 ''*/
    const savedKeyWord = window.sessionStorage
      .getItem("currentKeyword")
      ?.trim()
      .substring(0, 50)
      .replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\u200D|\uFE0F)/g,
        ""
      );
    if (givenKeyWord) {
      try {
        changeKeyword(givenKeyWord ? decodeURIComponent(givenKeyWord) : "");
        window.sessionStorage.setItem(
          "currentKeyword",
          givenKeyWord ? decodeURIComponent(givenKeyWord) : ""
        );
      } catch (e) {
        changeKeyword(givenKeyWord);
        window.sessionStorage.setItem("currentKeyword", givenKeyWord);
      }
    } else if (!givenKeyWord && savedKeyWord) {
      changeKeyword(savedKeyWord);
    } else {
      changeKeyword("");
    }
  }, [urlParmas]);

  useEffect(() => {
    changeWorkgroups(
      workgroupState.simpleWorkgroupList.filter(
        (item: Workgroup) => item.isValidate !== 0
      )
    );
    checkboxGroup.handleAllClick([
      "NONEWORKGROUP",
      ...workgroupState.simpleWorkgroupList.map(
        (item: Workgroup) => item.workgroupId
      ),
    ]);
    if (workgroupState.simpleWorkgroupList) {
      changeDocFilters({
        ...docFilter,
        search: keyword,
        tagCodes: [
          "NONEWORKGROUP",
          ...workgroupState.simpleWorkgroupList.map(
            (item: Workgroup) => item.workgroupId
          ),
        ],
      });
    }
  }, [workgroupState.simpleWorkgroupList]);
  useEffect(() => {
    changeDocInfo(documentState.docListInfo);
  }, [documentState.docListInfo]);
  useEffect(() => {
    changeMeetingList(meetingState.meetingList);
  }, [meetingState.meetingList]);
  useEffect(() => {
    if (docFilter.tagCodes.length > 0 && !!keyword)
      getContentList({ ...docFilter, search: keyword });
  }, [docFilter, keyword]);
  useEffect(() => {
    if (utilsCommon.checkMenuAvailable("zoom") && meetingFilter && !!keyword)
      getMeetingListBySearchKeyword({
        ...meetingFilter,
        searchKeyword: keyword,
      });
  }, [meetingFilter, keyword]);
  useEffect(() => {
    if (tab === 0) changeDocFilters({ ...docFilter, order: "datedesc" });
    else changeMeetingFilters({ ...meetingFilter, order: "datedesc" });
  }, [tab]);

  /** 함수 정리 */
  /** 필터 초기화 상태인지 확인*/
  const isInitFilter = () => {
    return (
      dayjs(INIT_MEETING_FILTER.date.start).diff(
        meetingFilter.date.start,
        "d"
      ) === 0 &&
      dayjs(INIT_MEETING_FILTER.date.end).diff(meetingFilter.date.end, "d") ===
        0 &&
      (meetingFilter.workgroupIds.length === 0 ||
        (tab === 0
          ? meetingFilter.workgroupIds.length ===
            workgroups.length + ["NONE_WORKGROUP"].length
          : meetingFilter.workgroupIds.filter(
              (item) => item !== "NONEWORKGROUP"
            ).length === workgroups.length)) &&
      (tab === 0
        ? docFilter.masterUserId === ""
        : meetingFilter.searchUser === "")
    );
  };
  /** 필터 수정 */
  const changeFilterByKey = (key: string, value: any) => {
    let newValue = value;
    if (key === "order") {
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "file" || value === "name") {
          if (meetingFilter.order.includes("date")) {
            newValue = "filedesc";
          } else {
            newValue = meetingFilter.order.includes("desc")
              ? "file"
              : "filedesc";
          }
        } else {
          if (meetingFilter.order.includes("file")) {
            newValue = "datedesc";
          } else {
            newValue = meetingFilter.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
    } else if (key === "date") {
      if (typeof value !== "object") {
        changeDateFilter(value);
        changeMeetingFilters({
          ...meetingFilter,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().endOf("day").valueOf(),
          },
        });
        changeDocFilters({
          ...docFilter,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().endOf("day").valueOf(),
          },
        });
      } else {
        changeDateFilter("custom");
        changeDocFilters({
          ...docFilter,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
        changeMeetingFilters({
          ...meetingFilter,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
      }
      document.getElementById("docTable")?.scrollTo(0, 0);
      return;
    } else if (key === "workgroupIds") {
      changeMeetingFilters({ ...meetingFilter, workgroupIds: newValue });
      changeDocFilters({
        ...docFilter,
        tagCodes: newValue,
      });
      document.getElementById("docTable")?.scrollTo(0, 0);
      return;
    } else if (key === "masterUserId") {
      changeSavedUsers(users);
      changeMeetingFilters({ ...meetingFilter, searchUser: value[0] });
      changeDocFilters({ ...docFilter, masterUserId: value[0] });
      document.getElementById("docTable")?.scrollTo(0, 0);
      return;
    } else if (key === "page") {
      if (
        docInfo &&
        docInfo?.docs?.doc &&
        docInfo?.docs?.doc.length < docInfo?.total
      )
        changeDocFilters({ ...docFilter, [key]: value });
      return;
    }
    document.getElementById("docTable")?.scrollTo(0, 0);
    changeMeetingFilters({
      ...meetingFilter,
      [key]: newValue.replace("file", "name"),
    });
    changeDocFilters({ ...docFilter, [key]: newValue.replace("name", "file") });
  };
  /** 필터 초기화 */
  const handleInitFilter = () => {
    changeMeetingFilters({
      ...meetingFilter,
      searchKeyword: keyword,
      date: {
        start: utilsCommon.getStartPeriod("1month"),
        end: dayjs().endOf("day").valueOf(),
      },
      searchUser: "",
      workgroupIds: [],
    });
    changeUsers([]);
    changeSavedUsers([]);
    changeDocFilters({
      ...docFilter,
      search: keyword,
      date: {
        start: utilsCommon.getStartPeriod("1month"),
        end: dayjs().endOf("day").valueOf(),
      },
      masterUserId: "",
      tagCodes: workgroupState.simpleWorkgroupList.map(
        (item: Workgroup) => item.workgroupId
      ),
    });
    changeDateFilter("1month");
    checkboxGroup.handleAllClick(
      workgroupState.simpleWorkgroupList.map(
        (item: Workgroup) => item.workgroupId
      )
    );
    document.getElementById("docTable")?.scrollTo(0, 0);
  };
  /** UI: 상단 필터 */
  const renderFilter = () => {
    return (
      <Box classes="fav-filter">
        <Button
          leadingIcon={<Icons variant="line" label="redoLeft" />}
          btnStyle="icon"
          size={"sm"}
          onClick={handleInitFilter}
          state={isInitFilter() ? "disable" : "default"}
        />
        <WorkgroupCheckboxDropdown
          buttonClick={buttonClick}
          meetingFilter={meetingFilter}
          workgroups={workgroups}
          tab={tab}
          changeFilterByKey={changeFilterByKey}
          setButtonClick={setButtonClick}
        />
        <DateDropdown
          filter={meetingFilter}
          buttonClick={buttonClick}
          dateFilter={dateFilter}
          initValue="1month"
          setButtonClick={setButtonClick}
          changeFilterByKey={changeFilterByKey}
        />
        <UserSearchDropdown
          buttonClick={buttonClick}
          filter={docFilter}
          users={users}
          savedUsers={savedUsers}
          isSingle
          isAllowEmptyUser
          pageFrom="search"
          isAllowNewUser={false}
          changeUsers={changeUsers}
          changeFilterByKey={changeFilterByKey}
          setButtonClick={setButtonClick}
          buttonTitle={tab === 0 ? t("file.master") : t("meeting.host")}
          title={tab === 0 ? t("file.master") : t("meeting.host")}
        />
      </Box>
    );
  };
  /** UI: 문서 검색 페이지 */
  const renderFavDoc = () => {
    return (
      <DocumentBottom
        filter={docFilter}
        docInfo={docInfo}
        page="search"
        changeFilterByKey={changeFilterByKey}
        height={"calc(100% - 200px)"}
        handleInitFilter={handleInitFilter}
        isInitFilter={isInitFilter()}
        endReached={() =>
          changeFilterByKey("page", (meetingFilter?.pageNo ?? 0) + 1)
        }
      />
    );
  };
  /** UI: 화상회의 검색 페이지 */
  const renderFavMeeting = () => {
    return (
      <Box classes="fav-body">
        <Box height={32}>
          <Typography type="subtitle2">
            <Trans
              i18nKey={"meeting.withCount"}
              components={{
                1: (
                  <Typography
                    type="subtitle2"
                    exactColor={getColor("COLOR_TEXT_BRAND")}
                    classes={"mg ml-4"}
                  />
                ),
              }}
              values={{ count: meetingList ? meetingList.length : 0 }}
            />
          </Typography>
        </Box>
        <MeetingBottom
          isInitFilter={
            dateFilter === "1month" &&
            checkboxGroup.selected.length === workgroups.length
          }
          handleInitFilter={handleInitFilter}
          changeFilterByKey={changeFilterByKey}
          meetingList={meetingList}
          height={"calc(100% - 32px)"}
          filter={meetingFilter}
          handleRefreshMeetingList={() =>
            getMeetingListBySearchKeyword(meetingFilter)
          }
          page={"search"}
        />
      </Box>
    );
  };

  return (
    <Box width={"100%"} height={"100%"} classes={"fav body"}>
      <Box height={96} classes={"layout-title"} justifyContent="flex-start">
        <Box width={32} classes="cursor pointer" onClick={() => navigate(-1)}>
          <Icons variant="line" label="arrow" />
        </Box>
        <Typography type="h2" whiteSpace="pre" style={{ display: "flex" }}>
          <Trans
            i18nKey="search.title"
            values={{ keyword: keyword }}
            components={{
              1: (
                <Typography
                  type="h2"
                  ellipsis
                  maxWidth={600}
                  exactColor={getColor("COLOR_TEXT_BRAND")}
                />
              ),
            }}
          />
        </Typography>
      </Box>
      <Tabs
        type={"leftFull"}
        selectTab={(tab) => changeTab(tab)}
        selected={tab}
        size={"lg"}
        paddingLeft={32}
        tabs={[t("common.file"), t("common.meetings")].map((item, index) => {
          return {
            text: item,
            color: "default",
            isNew: false,
            isHidden:
              index === 1 && utilsCommon.checkMenuAvailable("zoom") === false,
          };
        })}
      />
      {renderFilter()}
      {tab === 0 ? renderFavDoc() : renderFavMeeting()}
    </Box>
  );
};

export default Search;
